{
  const itemList = document.querySelector('.product-grid');
  const items = itemList.querySelectorAll('.grid__item');
  const images = document.querySelectorAll('.collection__image')

  const insertIndex = Math.ceil(items.length / (images.length + 1));

  images.forEach((image, index) => {
    const item = items[(index + 1) * insertIndex];
    item.parentNode.insertBefore(image, item);
  });
}